import type { CSSProperties } from "react";
import type { BlockImageEffect } from "@newxsystems/types";

/**
 * Hardcoded per-effect opacity, tuned so busy styles never swallow the copy they sit
 * behind. Not CMS-configurable: the `effect`/`animation` field only chooses the style.
 * One map for every effect surface — hero background and image overlay read the same
 * numbers, so a style cannot look denser in one place than the other.
 */
export const FX_OPACITY: Partial<Record<BlockImageEffect, number>> = {
  lightfall: 0.7,
  "aero-shards": 0.7,
  "shape-waves": 0.7,
  dither: 0.7,
  "pattern-waves": 0.7,
  aurora: 0.7,
};

/**
 * The effect canvas is styled by host code (the stage's worker host, or the shared host
 * in fallback mode), so each style's container classes/styles live here — one source for
 * both paths. Styles without an entry take the plain defaults.
 */
export const FX_SURFACE: Partial<
  Record<BlockImageEffect, { containerClass?: string; containerStyle?: CSSProperties }>
> = {
  // The translucent waves read only over a dark base; the container keeps the backdrop.
  "gradient-waves": { containerClass: "bg-[#05060a]/65" },
  // The prism is additive light: over the bright photograph it washes to white. The
  // reactbits demo renders it on a near-black page, so the panel keeps a dark base.
  prism: { containerClass: "bg-[#05060a]/85" },
  // GradientBlinds composites with `lighten` over the photograph; without it, the
  // gradient's dark bands would ink the whole hero.
  "gradient-blinds": { containerStyle: { mixBlendMode: "lighten" } },
};
